// LABİRENTLİLER + TETRALAR - balikVeritabani4.js
// Wikipedia Commons ücretsiz resimler kullanılmıştır

export const labirentliler = {
  kategori: {
    id: 'labirentliler',
    isim: 'Labirentliler',
    emoji: '🌸',
    renk: '#e91e63',
    aciklama: 'Hava soluyan labirent balıkları - Betta, Gurami ve akrabaları'
  },
  baliklar: [
    {
      id: 'betta-splendens',
      isim: 'Betta (Kavgacı Balık)',
      latince: 'Betta splendens',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Betta_splendens_HM.jpg/1280px-Betta_splendens_HM.jpg',
      zorluk: 'Kolay',
      genel: 'Siyam kavgacı balığı. Tayland kökenli. Labirent organı sayesinde yüzeyden hava alabilir. Erkekler birbirine karşı çok agresif.',
      minLitre: 20,
      maxBoy: 7,
      sicaklik: { min: 24, max: 30 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '2-4 yıl',
      bolge: 'Üst',
      beslenme: 'Karnivor - Betta peleti, canlı/dondurulmuş yem (kan kurdu, artemia).',
      uyumlu: ['Corydoras', 'Küçük Tetralar (dikkatli)', 'Rasbora', 'Salyangoz', 'Karides (dikkatli)'],
      uyumsuz: ['Diğer Betta erkekleri', 'Guppy (benzer görünüm)', 'Parlak renkli balıklar', 'Yüzgeç ısırıcılar', 'Agresif türler'],
      ureme: 'Köpük yuvası yapıcı. Erkek yüzeyde köpük yuvası yapar.',
      eslesme: 'Erkek köpük yuvası yapar, dişiyi çağırır. Sarılma (amplexus) ile yumurta bırakılır. Erkek yumurtaları toplar ve korur.',
      grupSayisi: 'TEK ERKEK! Dişiler birlikte tutulabilir (sorority - en az 5).',
      disiErkek: 'Erkekler büyük, renkli, uzun yüzgeçli. Dişiler küçük, kısa yüzgeçli, soluk renkli.',
      gorunus: 'Yüzlerce renk ve yüzgeç formu. Halfmoon, Crowntail, Plakat, Veiltail, Double Tail. Kırmızı, mavi, mor, beyaz, siyah, multicolor.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'betta-imbellis',
      isim: 'Peaceful Betta',
      latince: 'Betta imbellis',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Betta_imbellis_male.jpg/1280px-Betta_imbellis_male.jpg',
      zorluk: 'Orta',
      genel: 'Crescent Betta. B. splendens\'ten daha az agresif. Doğal görünümlü, yabani tip.',
      minLitre: 40,
      maxBoy: 6,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 2, max: 10 },
      yasam: '3-5 yıl',
      bolge: 'Üst',
      beslenme: 'Karnivor - Küçük canlı ve dondurulmuş yem.',
      uyumlu: ['Küçük barışçıl balıklar', 'Karides'],
      uyumsuz: ['B. splendens (melezlenir)', 'Agresif türler'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'B. splendens gibi ama daha sakin.',
      grupSayisi: 'Çift veya harem (yeterli alanla)',
      disiErkek: 'Erkekler daha renkli.',
      gorunus: 'Mavi-yeşil vücut, kırmızı hilal şeklinde kuyruk kenarı. Doğal, yabani görünüm.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'betta-mahachaiensis',
      isim: 'Mahachai Betta',
      latince: 'Betta mahachaiensis',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Betta_mahachaiensis.jpg/1280px-Betta_mahachaiensis.jpg',
      zorluk: 'Orta',
      genel: 'Tayland\'ın acı sularında yaşayan yabani Betta. Tuzlu suya toleranslı.',
      minLitre: 40,
      maxBoy: 6,
      sicaklik: { min: 24, max: 30 },
      ph: { min: 7.0, max: 8.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '3-5 yıl',
      bolge: 'Üst',
      beslenme: 'Karnivor',
      uyumlu: ['Tuzlu su toleranslı türler'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'Standart Betta davranışı.',
      grupSayisi: 'Tek erkek veya çift',
      disiErkek: 'Erkekler yeşil-mavi metalik, daha uzun yüzgeçler.',
      gorunus: 'Metalik yeşil-mavi pullar. Siyah solungaç çizgileri.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'dwarf-gourami',
      isim: 'Cüce Gurami',
      latince: 'Trichogaster lalius',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Trichogaster_lalius.jpg/1280px-Trichogaster_lalius.jpg',
      zorluk: 'Kolay',
      genel: 'Hindistan kökenli popüler gurami. Güzel renkleri ve sakin yapısıyla topluluk akvaryumlarının favorisi.',
      minLitre: 60,
      maxBoy: 9,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '4-6 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor - Pul yem, pellet, canlı ve dondurulmuş yem.',
      uyumlu: ['Tetralar', 'Rasbora', 'Corydoras', 'Küçük barışçıl balıklar'],
      uyumsuz: ['Agresif balıklar', 'Çok aktif türler', 'Diğer Gurami erkekleri'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'Erkek köpük yuvası yapar.',
      grupSayisi: '1 erkek / 2 dişi veya tek erkek',
      disiErkek: 'Erkekler çok renkli (kırmızı-mavi çizgili). Dişiler gümüşi.',
      gorunus: 'Flame (turuncu-kırmızı), Powder Blue (mavi), Neon Blue, Royal Blue, Honey (sarı-turuncu) varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'honey-gourami',
      isim: 'Bal Gurami',
      latince: 'Trichogaster chuna',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Trichogaster_chuna.jpg/1280px-Trichogaster_chuna.jpg',
      zorluk: 'Kolay',
      genel: 'Cüce Gurami\'den daha küçük ve daha utangaç. Bal sarısı rengiyle çekici. Dwarf Gourami Iridovirus\'a daha dayanıklı.',
      minLitre: 40,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 4, max: 15 },
      yasam: '4-8 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor - Küçük yemler tercih eder.',
      uyumlu: ['Küçük barışçıl balıklar', 'Tetralar', 'Rasbora', 'Corydoras'],
      uyumsuz: ['Büyük veya agresif balıklar', 'Yem rakipleri'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'Erkek köpük yuvası yapar.',
      grupSayisi: 'Çift veya 1 erkek / 2 dişi',
      disiErkek: 'Erkekler parlak bal sarısı-turuncu, koyu boğaz. Dişiler soluk bej-kahverengi.',
      gorunus: 'Erkekler bal sarısı-turuncu, üreme döneminde koyu lacivert boğaz. Red Honey ve Sunset varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'pearl-gourami',
      isim: 'İnci Gurami',
      latince: 'Trichopodus leerii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Trichopodus_leerii.jpg/1280px-Trichopodus_leerii.jpg',
      zorluk: 'Kolay',
      genel: 'En güzel gurami türlerinden biri. İnci benzeri beyaz noktalarla kaplı. Barışçıl ve zarif.',
      minLitre: 120,
      maxBoy: 12,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '4-5 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Barışçıl topluluk balıkları', 'Tetralar', 'Rasbora', 'Corydoras', 'Barışçıl orta boy balıklar'],
      uyumsuz: ['Agresif türler', 'Yüzgeç ısırıcılar'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'Erkek köpük yuvası yapar.',
      grupSayisi: '1 erkek / 1-2 dişi',
      disiErkek: 'Erkeklerin göğsü üreme döneminde turuncuya döner, daha uzun yüzgeçler.',
      gorunus: 'Gümüşi vücut üzerinde inci benzeri beyaz noktalar. Siyah yatay çizgi. Erkeklerde turuncu göğüs.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'moonlight-gourami',
      isim: 'Moonlight Gurami',
      latince: 'Trichopodus microlepis',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Moonlight_gourami.jpg/1280px-Moonlight_gourami.jpg',
      zorluk: 'Kolay',
      genel: 'Gümüşi ay ışığı parlaması. Çok barışçıl. Büyük ama sakin.',
      minLitre: 150,
      maxBoy: 15,
      sicaklik: { min: 26, max: 30 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 2, max: 12 },
      yasam: '4-6 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Barışçıl topluluk balıkları'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'Erkek büyük köpük yuvası yapar.',
      grupSayisi: 'Çift',
      disiErkek: 'Erkeklerin karın yüzgeci turuncu-kırmızı.',
      gorunus: 'Tüm vücut gümüşi, yeşilimsi-mavimsi yansıma. Ay ışığı etkisi.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'blue-gourami',
      isim: 'Mavi Gurami (Three-Spot)',
      latince: 'Trichopodus trichopterus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Trichopodus_trichopterus.jpg/1280px-Trichopodus_trichopterus.jpg',
      zorluk: 'Kolay',
      genel: 'Üç nokta guramisi. İki yan nokta + göz = 3 nokta. Dayanıklı ama erkekler agresif olabilir.',
      minLitre: 120,
      maxBoy: 12,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '4-6 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor - Her şeyi yer.',
      uyumlu: ['Eşit boy dayanıklı balıklar'],
      uyumsuz: ['Diğer Gurami erkekleri', 'Küçük balıklar'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'Erkek agresif olabilir.',
      grupSayisi: 'Tek erkek veya 1 erkek / 2+ dişi',
      disiErkek: 'Erkekler daha sivri sırt yüzgeci.',
      gorunus: 'Blue, Gold, Opaline (marbled), Platinum (beyaz) varyasyonları. İki koyu yan nokta.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'gold-gourami',
      isim: 'Gold Gurami',
      latince: 'Trichopodus trichopterus var.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Gold_gourami.jpg/1280px-Gold_gourami.jpg',
      zorluk: 'Kolay',
      genel: 'Mavi Gurami\'nin altın sarısı renk formu. Aynı davranış ve bakım.',
      minLitre: 120,
      maxBoy: 12,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '4-6 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Eşit boy dayanıklı balıklar'],
      uyumsuz: ['Diğer Gurami erkekleri', 'Küçük balıklar'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'Standart Three-Spot davranışı.',
      grupSayisi: 'Tek erkek veya 1 erkek / 2+ dişi',
      disiErkek: 'Erkekler daha sivri yüzgeçler.',
      gorunus: 'Altın sarısı-turuncu vücut. Yan noktalar az belirgin.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'kissing-gourami',
      isim: 'Öpüşen Gurami',
      latince: 'Helostoma temminckii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Kissing_gourami.jpg/1280px-Kissing_gourami.jpg',
      zorluk: 'Orta',
      genel: 'Öpüşme davranışıyla ünlü (aslında güç gösterisi). Çok büyüyebilir. Alg yer.',
      minLitre: 300,
      maxBoy: 30,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '5-7 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Alg yeme uzmanı. Sebze, spirulina.',
      uyumlu: ['Eşit boy dayanıklı balıklar'],
      uyumsuz: ['Küçük balıklar', 'Yavaş türler'],
      ureme: 'Yüzer yumurtlayıcı (köpük yuvası yapmaz).',
      eslesme: 'Öpüşme = kavga. Yumurtalar yüzer.',
      grupSayisi: 'Tek veya grup',
      disiErkek: 'Cinsiyet ayrımı çok zor.',
      gorunus: 'Pembe (albino) veya yeşil-gümüşi. Kalın dudaklar. Pembe form daha popüler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'paradise-fish',
      isim: 'Cennet Balığı',
      latince: 'Macropodus opercularis',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Macropodus_opercularis_-_couple.jpg/1280px-Macropodus_opercularis_-_couple.jpg',
      zorluk: 'Kolay',
      genel: 'Akvaryumculuğa giren ilk tropikal balıklardan biri (1869). Çok dayanıklı, soğuğa toleranslı. Agresif olabilir.',
      minLitre: 80,
      maxBoy: 10,
      sicaklik: { min: 16, max: 26 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '6-8 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor - Her şeyi yer.',
      uyumlu: ['Dayanıklı, hızlı balıklar', 'Büyük Barb', 'Büyük Tetra'],
      uyumsuz: ['Yavaş, uzun yüzgeçli balıklar', 'Betta', 'Küçük balıklar', 'Diğer erkek Paradise'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'Erkek köpük yuvası yapar, dişiye agresif olabilir.',
      grupSayisi: 'Tek erkek veya çift (büyük tanklarda)',
      disiErkek: 'Erkekler daha parlak, daha uzun yüzgeçler.',
      gorunus: 'Kırmızı ve mavi dikey çizgiler. Çatallı kuyruk. Blue, Albino varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'giant-gourami',
      isim: 'Dev Gurami',
      latince: 'Osphronemus goramy',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Osphronemus_goramy.jpg/1280px-Osphronemus_goramy.jpg',
      zorluk: 'Zor',
      genel: 'Gerçek dev - 60 cm\'e ulaşabilir! Güneydoğu Asya\'da yiyecek balığı olarak yetiştirilir. Çok büyük tank gerektirir.',
      minLitre: 1000,
      maxBoy: 60,
      sicaklik: { min: 20, max: 30 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 5, max: 25 },
      yasam: '20+ yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Sebze, meyve, pellet, balık. Bitkisel ağırlıklı.',
      uyumlu: ['Diğer dev balıklar'],
      uyumsuz: ['Küçük tüm balıklar'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'Büyük köpük yuvası.',
      grupSayisi: 'Tek veya çift (çok büyük tank)',
      disiErkek: 'Erkeklerde baş daha yuvarlak, dudaklar daha kalın.',
      gorunus: 'Gençken çizgili. Yetişkinler gri-pembe, büyük dudaklı. Pink Giant en popüler form.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'chocolate-gourami',
      isim: 'Çikolata Gurami',
      latince: 'Sphaerichthys osphromenoides',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Chocolate_gourami.jpg/1280px-Chocolate_gourami.jpg',
      zorluk: 'Zor',
      genel: 'Çikolata kahverengisi renk. Çok hassas, yumuşak asidik su şart. Ağız kuluçkacı (guramiler arasında nadir).',
      minLitre: 80,
      maxBoy: 6,
      sicaklik: { min: 25, max: 28 },
      ph: { min: 4.0, max: 6.5 },
      sertlik: { min: 0, max: 4 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Küçük canlı ve dondurulmuş yem.',
      uyumlu: ['Küçük, sakin yumuşak su balıkları'],
      uyumsuz: ['Agresif balıklar', 'Sert su balıkları'],
      ureme: 'Ağız kuluçkacı! Dişi ağzında yumurta taşır.',
      eslesme: 'Dişi ağız kuluçkalama - guramiler arasında benzersiz.',
      grupSayisi: 'Çift veya küçük grup',
      disiErkek: 'Erkeklerin boğazı düz, dişilerin boğazında yuvarlak hat.',
      gorunus: 'Çikolata kahverengisi vücut, dikey krem-sarı bantlar.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'sparkling-gourami',
      isim: 'Sparkling Gurami',
      latince: 'Trichopsis pumila',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Trichopsis_pumila.jpg/1280px-Trichopsis_pumila.jpg',
      zorluk: 'Orta',
      genel: 'Pygmy Gourami. Çok küçük ve ses çıkarır (croaking). Nano tanklar için ideal.',
      minLitre: 30,
      maxBoy: 4,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 3, max: 12 },
      yasam: '4-5 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor - Küçük yemler.',
      uyumlu: ['Küçük barışçıl balıklar', 'Nano tank sakinleri'],
      uyumsuz: ['Büyük balıklar', 'Agresif türler'],
      ureme: 'Köpük yuvası yapıcı.',
      eslesme: 'Küçük köpük yuvası.',
      grupSayisi: '3-6 (küçük grup)',
      disiErkek: 'Ayrımı zor, erkekler biraz daha parlak.',
      gorunus: 'Kahverengimsi vücut, mavi-yeşil parıltılı noktalar. Işıkta \'parıldar\'.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'licorice-gourami',
      isim: 'Licorice Gurami',
      latince: 'Parosphromenus deissneri',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Parosphromenus_deissneri.jpg/1280px-Parosphromenus_deissneri.jpg',
      zorluk: 'Zor',
      genel: 'Çok küçük ve hassas. Blackwater habitatı gerektirir. Nesli tehlike altında.',
      minLitre: 30,
      maxBoy: 4,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 4.0, max: 6.0 },
      sertlik: { min: 0, max: 3 },
      yasam: '3-5 yıl',
      bolge: 'Orta',
      beslenme: 'Karnivor - Sadece canlı/dondurulmuş küçük yemler.',
      uyumlu: ['Aynı habitat gereksinimleri olan küçük balıklar'],
      uyumsuz: ['Çoğu topluluk balığı', 'Yem rakipleri'],
      ureme: 'Mağara yumurtlayıcı.',
      eslesme: 'Mağarada ürer, erkek yumurtaları korur.',
      grupSayisi: 'Çift veya küçük grup',
      disiErkek: 'Erkekler renkli yüzgeçler.',
      gorunus: 'Koyu kahverengi-siyah vücut, erkeklerin yüzgeçlerinde mavi-kırmızı renkler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    }
  ]
};

export const tetralar = {
  kategori: {
    id: 'tetralar',
    isim: 'Tetralar',
    emoji: '✨',
    renk: '#00bcd4',
    aciklama: 'Characin ailesi - Güney Amerika\'nın renkli sürü balıkları'
  },
  baliklar: [
    {
      id: 'neon-tetra',
      isim: 'Neon Tetra',
      latince: 'Paracheirodon innesi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Paracheirodon_innesi_1.jpg/1280px-Paracheirodon_innesi_1.jpg',
      zorluk: 'Kolay',
      genel: 'Akvaryum hobisinin en ikonik balığı. Peru kökenli. Mavi ve kırmızı neon renkleri ile büyüleyici sürü davranışı.',
      minLitre: 60,
      maxBoy: 4,
      sicaklik: { min: 20, max: 26 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 2, max: 10 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Küçük taneli pul yem, mikro pellet, dondurulmuş yem.',
      uyumlu: ['Diğer Tetralar', 'Corydoras', 'Rasbora', 'Küçük Gurami', 'Karides', 'Otocinclus'],
      uyumsuz: ['Büyük balıklar', 'Angel (yetişkin)', 'Agresif türler'],
      ureme: 'Yumurtlayan. Akvaryumda zor ürer. Yumuşak, asidik su ve loş ışık gerekir.',
      eslesme: 'Yumurtalar dağılır, ebeveyn bakımı yok.',
      grupSayisi: '10+ (sürü balığı)',
      disiErkek: 'Dişiler daha tombul. Mavi çizgi dişilerde daha kıvrık.',
      gorunus: 'Neon mavi çizgi burndan kuyruk kökine. Karın arkası parlak kırmızı. Küçük ve zarif.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'cardinal-tetra',
      isim: 'Cardinal Tetra',
      latince: 'Paracheirodon axelrodi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Paracheirodon_axelrodi.jpg/1280px-Paracheirodon_axelrodi.jpg',
      zorluk: 'Orta',
      genel: 'Neon Tetra\'ya benzer ama daha parlak. Kırmızı bant TÜM alt vücudu kaplar. Rio Negro blackwater balığı.',
      minLitre: 80,
      maxBoy: 5,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 5.0, max: 7.0 },
      sertlik: { min: 1, max: 8 },
      yasam: '4-5 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Küçük taneli yemler.',
      uyumlu: ['Diğer Tetralar', 'Corydoras', 'Apistogramma', 'Discus'],
      uyumsuz: ['Büyük balıklar', 'Sert su balıkları'],
      ureme: 'Yumurtlayan. Çok yumuşak su gerektirir.',
      eslesme: 'Düşük pH ve sertlikte şansı artar.',
      grupSayisi: '10+ (sürü balığı)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Neon\'dan farkı: kırmızı bant tüm vücudu kaplar (Neon\'da sadece arka yarı). Daha canlı renkler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'rummy-nose-tetra',
      isim: 'Rummy Nose Tetra',
      latince: 'Hemigrammus rhodostomus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Hemigrammus_rhodostomus.jpg/1280px-Hemigrammus_rhodostomus.jpg',
      zorluk: 'Orta',
      genel: 'Kırmızı burnu ve siyah-beyaz çizgili kuyruğuyla tanınır. En iyi sürü davranışı gösteren tetralardan biri.',
      minLitre: 80,
      maxBoy: 5,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 2, max: 10 },
      yasam: '5-6 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Tetralar', 'Corydoras', 'Discus', 'Angel', 'Barışçıl cikletler'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Yumuşak suda.',
      grupSayisi: '10+ (sürü balığı)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Şeffaf vücut, parlak kırmızı burun/kafa, siyah-beyaz çizgili kuyruk. Su kalitesi düşünce burun rengi solar - su kalitesi göstergesi!',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'black-neon-tetra',
      isim: 'Black Neon Tetra',
      latince: 'Hyphessobrycon herbertaxelrodi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Hyphessobrycon_herbertaxelrodi.jpg/1280px-Hyphessobrycon_herbertaxelrodi.jpg',
      zorluk: 'Kolay',
      genel: 'Dayanıklı bir tetra türü. Siyah ve altın çizgileriyle zarif görünüm. Gerçek Neon\'la ilişkisi yok.',
      minLitre: 60,
      maxBoy: 4,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Tetralar', 'Corydoras', 'Rasbora', 'Barışçıl türler'],
      uyumsuz: ['Büyük balıklar'],
      ureme: 'Yumurtlayan. Diğer tetralara göre kolay.',
      eslesme: 'Yumurtalar bitkiler arasına dağılır.',
      grupSayisi: '8+ (sürü balığı)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Siyah bant üzerinde parlak altın sarısı çizgi. Gözler kırmızımsı.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'ember-tetra',
      isim: 'Ember Tetra',
      latince: 'Hyphessobrycon amandae',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Hyphessobrycon_amandae.jpg/1280px-Hyphessobrycon_amandae.jpg',
      zorluk: 'Kolay',
      genel: 'Çok küçük ve turuncu renkli. Nano akvaryumlar için mükemmel. Amanda Bleher onuruna isimlendirilmiş.',
      minLitre: 30,
      maxBoy: 2,
      sicaklik: { min: 23, max: 29 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 5, max: 15 },
      yasam: '2-4 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Çok küçük taneli yemler, mikro pellet.',
      uyumlu: ['Küçük Tetralar', 'Karides', 'Küçük Rasbora', 'Otocinclus', 'Corydoras pygmaeus'],
      uyumsuz: ['Tüm büyük balıklar'],
      ureme: 'Yumurtlayan. Bitkili akvaryumda spontan üreme olabilir.',
      eslesme: 'Yumurtalar bitkilere dağılır.',
      grupSayisi: '10+ (sürü balığı)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Tamamen turuncu-kırmızı renk. Kor gibi parlar. Çok küçük ve zarif.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'serpae-tetra',
      isim: 'Serpae Tetra',
      latince: 'Hyphessobrycon eques',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Hyphessobrycon_eques.jpg/1280px-Hyphessobrycon_eques.jpg',
      zorluk: 'Kolay',
      genel: 'Blood Tetra, Red Minor Tetra. Parlak kırmızı renk. Yüzgeç ısırıcı olabilir - dikkat!',
      minLitre: 80,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-7 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer aktif, dayanıklı Tetralar', 'Barb', 'Corydoras'],
      uyumsuz: ['Uzun yüzgeçli balıklar (Betta, Angel)', 'Yavaş balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Kolay ürer.',
      grupSayisi: '8+ (büyük grupta yüzgeç ısırma azalır)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Parlak kan kırmızısı vücut. Siyah omuza yakın leke. Siyah sırt yüzgeci.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'bleeding-heart-tetra',
      isim: 'Bleeding Heart Tetra',
      latince: 'Hyphessobrycon erythrostigma',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Bleeding_heart_tetra.jpg/1280px-Bleeding_heart_tetra.jpg',
      zorluk: 'Orta',
      genel: 'Kanayan kalp - kırmızı kalp şeklinde yandaki lekeden adını alır. Tetralar arasında büyük boylu.',
      minLitre: 120,
      maxBoy: 8,
      sicaklik: { min: 23, max: 28 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 4, max: 12 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer büyük Tetralar', 'Barışçıl orta boy balıklar', 'Angel', 'Corydoras'],
      uyumsuz: ['Küçük balıklar', 'Agresif türler'],
      ureme: 'Yumurtlayan. Zor ürer.',
      eslesme: 'Yumuşak su gerekir.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Erkeklerin sırt yüzgeci daha uzun ve sivri.',
      gorunus: 'Pembe-bej vücut, yanda kırmızı kalp şeklinde leke. Erkeklerde uzun, orak şeklinde sırt yüzgeci.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'congo-tetra',
      isim: 'Congo Tetra',
      latince: 'Phenacogrammus interruptus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Phenacogrammus_interruptus.jpg/1280px-Phenacogrammus_interruptus.jpg',
      zorluk: 'Orta',
      genel: 'Afrika\'nın en güzel tetrası. Gökkuşağı renkleri ve ipeksi yüzgeçler. Kongo Nehri\'nden.',
      minLitre: 150,
      maxBoy: 8,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 3, max: 15 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Pul, pellet, canlı ve dondurulmuş yem.',
      uyumlu: ['Diğer büyük Tetralar', 'Barışçıl cikletler', 'Corydoras', 'Synodontis'],
      uyumsuz: ['Yüzgeç ısırıcılar', 'Agresif türler'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Erkekler gösteriş yapar.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Erkekler daha büyük, daha renkli, çok uzun ipeksi yüzgeçler.',
      gorunus: 'Gökkuşağı renkleri - mavi, yeşil, altın, turuncu yansımalar. Erkeklerin ortası yüzgeçleri çok uzun.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'lemon-tetra',
      isim: 'Lemon Tetra',
      latince: 'Hyphessobrycon pulchripinnis',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Hyphessobrycon_pulchripinnis.jpg/1280px-Hyphessobrycon_pulchripinnis.jpg',
      zorluk: 'Kolay',
      genel: 'Limon sarısı şeffaf vücut. Dayanıklı ve zarif. Kırmızı göz çemberi dikkat çekici.',
      minLitre: 60,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Tetralar', 'Rasbora', 'Corydoras', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Büyük balıklar', 'Agresif türler'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Kolay ürer.',
      grupSayisi: '8+ (sürü)',
      disiErkek: 'Erkekler daha parlak sarı.',
      gorunus: 'Şeffaf limon sarısı vücut. Kırmızı göz üst yarısı. Anal yüzgeçte siyah-sarı kenar.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'diamond-tetra',
      isim: 'Diamond Tetra',
      latince: 'Moenkhausia pittieri',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Diamond_tetra.jpg/1280px-Diamond_tetra.jpg',
      zorluk: 'Kolay',
      genel: 'Pırıl pırıl elmas gibi parlar. Venezuela\'dan. Işıkta muhteşem yansımalar.',
      minLitre: 80,
      maxBoy: 6,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Tetralar', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Kolay ürer.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Erkeklerin sırt yüzgeci daha uzun.',
      gorunus: 'Gümüşi vücut, elmas gibi ışık yansıtır. Gözde kırmızı üst yarı. Erkeklerde uzun sırt yüzgeci.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'green-neon-tetra',
      isim: 'Green Neon Tetra',
      latince: 'Paracheirodon simulans',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Paracheirodon_simulans.jpg/1280px-Paracheirodon_simulans.jpg',
      zorluk: 'Orta',
      genel: 'Neon ve Cardinal\'ın küçük kuzeni. Daha yeşil-mavi tonlar. Rio Negro blackwater türü.',
      minLitre: 60,
      maxBoy: 3,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 5.0, max: 6.5 },
      sertlik: { min: 1, max: 5 },
      yasam: '3-5 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Çok küçük yemler.',
      uyumlu: ['Küçük Tetralar', 'Karides', 'Yumuşak su balıkları'],
      uyumsuz: ['Büyük balıklar', 'Sert su balıkları'],
      ureme: 'Yumurtlayan. Zor.',
      eslesme: 'Çok yumuşak, asidik su.',
      grupSayisi: '10+ (sürü)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Neon\'dan küçük. Daha yeşil-turkuaz mavi çizgi. Kırmızı daha az belirgin.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'glowlight-tetra',
      isim: 'Glowlight Tetra',
      latince: 'Hemigrammus erythrozonus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Hemigrammus_erythrozonus.jpg/1280px-Hemigrammus_erythrozonus.jpg',
      zorluk: 'Kolay',
      genel: 'Parlayan çizgisi ile tanınır. Guyana\'dan. Dayanıklı ve güzel.',
      minLitre: 60,
      maxBoy: 4,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Tetralar', 'Rasbora', 'Corydoras', 'Barışçıl balıklar'],
      uyumsuz: ['Büyük balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Düşük ışıkta, yumuşak su.',
      grupSayisi: '8+ (sürü)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Şeffaf vücut, burndan kuyruğa parlak turuncu-kırmızı çizgi.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'silvertip-tetra',
      isim: 'Silvertip Tetra',
      latince: 'Hasemania nana',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Hasemania_nana.jpg/1280px-Hasemania_nana.jpg',
      zorluk: 'Kolay',
      genel: 'Yüzgeç uçlarındaki gümüşi-beyaz noktalarla tanınır. Aktif yüzücü, dayanıklı.',
      minLitre: 60,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '5-8 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer aktif Tetralar', 'Barb', 'Corydoras'],
      uyumsuz: ['Uzun yüzgeçli balıklar (ısırabilir)', 'Yavaş balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Kolay ürer.',
      grupSayisi: '8+ (sürü)',
      disiErkek: 'Erkekler daha sarı-bakır renkli.',
      gorunus: 'Bakır-sarı vücut, yüzgeç uçlarında gümüşi-beyaz noktalar.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'buenos-aires-tetra',
      isim: 'Buenos Aires Tetra',
      latince: 'Hyphessobrycon anisitsi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Buenos_Aires_tetra.jpg/1280px-Buenos_Aires_tetra.jpg',
      zorluk: 'Kolay',
      genel: 'Arjantin kökenli dayanıklı tetra. DİKKAT: Bitkileri yer! Bitkisiz tank için.',
      minLitre: 100,
      maxBoy: 7,
      sicaklik: { min: 18, max: 28 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 25 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - BİTKİLERİ YER! Sebze verin.',
      uyumlu: ['Dayanıklı, eşit boy balıklar'],
      uyumsuz: ['Bitkili akvaryumlar', 'Yavaş, küçük balıklar'],
      ureme: 'Yumurtlayan. Kolay ürer.',
      eslesme: 'Verimli ürer.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Erkekler daha parlak, kırmızı yüzgeçler.',
      gorunus: 'Gümüşi vücut, kırmızı yüzgeçler. Kuyruk dibinde siyah leke.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'x-ray-tetra',
      isim: 'X-Ray Tetra',
      latince: 'Pristella maxillaris',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Pristella_maxillaris.jpg/1280px-Pristella_maxillaris.jpg',
      zorluk: 'Kolay',
      genel: 'Röntgen balığı - şeffaf vücudu ile tanınır. Çok dayanıklı, başlangıç için ideal.',
      minLitre: 60,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 25 },
      yasam: '5-7 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Çoğu topluluk balığı', 'Tetralar', 'Rasbora', 'Corydoras'],
      uyumsuz: ['Büyük avcı balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Kolay ürer.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Şeffaf vücut, omurga görünür. Sarı-siyah-beyaz yüzgeç desenleri.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'emperor-tetra',
      isim: 'Emperor Tetra',
      latince: 'Nematobrycon palmeri',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Nematobrycon_palmeri.jpg/1280px-Nematobrycon_palmeri.jpg',
      zorluk: 'Kolay',
      genel: 'İmparator tetrası. Kolombiya\'dan. Erkeklerin üç çatallı kuyruğu dikkat çekici.',
      minLitre: 80,
      maxBoy: 6,
      sicaklik: { min: 23, max: 27 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 3, max: 10 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Barışçıl Tetralar', 'Rasbora', 'Corydoras', 'Küçük barışçıl balıklar'],
      uyumsuz: ['Çok aktif balıklar', 'Agresif türler'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Erkekler hafif territorial.',
      grupSayisi: '6+ (1 erkek baskın olur)',
      disiErkek: 'Erkekler mor-mavi tonlar, üç çatallı kuyruk. Dişiler daha soluk.',
      gorunus: 'Mor-mavi-siyah renk. Mavi gözler. Erkeklerin kuyruğu üç uçlu (trident).',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'flame-tetra',
      isim: 'Flame Tetra',
      latince: 'Hyphessobrycon flammeus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Hyphessobrycon_flammeus.jpg/1280px-Hyphessobrycon_flammeus.jpg',
      zorluk: 'Kolay',
      genel: 'Alev tetrası. Rio de Janeiro çevresinden. Dayanıklı ve kolay bakılır.',
      minLitre: 60,
      maxBoy: 4,
      sicaklik: { min: 20, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-7 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Tetralar', 'Rasbora', 'Corydoras', 'Barışçıl balıklar'],
      uyumsuz: ['Büyük balıklar'],
      ureme: 'Yumurtlayan. Kolay ürer.',
      eslesme: 'Bitkiler arasında.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Erkekler daha kırmızı, siyah anal yüzgeç kenarı.',
      gorunus: 'Ön yarı gümüşi, arka yarı alev kırmızısı. Omuzda iki siyah dikey leke.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'black-phantom-tetra',
      isim: 'Black Phantom Tetra',
      latince: 'Hyphessobrycon megalopterus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Hyphessobrycon_megalopterus.jpg/1280px-Hyphessobrycon_megalopterus.jpg',
      zorluk: 'Kolay',
      genel: 'Siyah hayalet. Erkeklerin dramatik gösterişi çarpıcı. Bolivya ve Brezilya\'dan.',
      minLitre: 80,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-7 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Tetralar', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Erkekler gösteriş yapar.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Erkekler siyah, büyük yüzgeçler. Dişiler kırmızımsı, küçük yüzgeçler.',
      gorunus: 'Erkekler: Grimsi-siyah, devasa siyah sırt yüzgeci. Dişiler: Kırmızı yüzgeçler. Yanda siyah omuz lekesi.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'red-phantom-tetra',
      isim: 'Red Phantom Tetra',
      latince: 'Hyphessobrycon sweglesi',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Hyphessobrycon_sweglesi.jpg/1280px-Hyphessobrycon_sweglesi.jpg',
      zorluk: 'Orta',
      genel: 'Kırmızı hayalet. Black Phantom\'un kırmızı versiyonu değil, ayrı tür.',
      minLitre: 80,
      maxBoy: 4,
      sicaklik: { min: 23, max: 27 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 3, max: 10 },
      yasam: '5 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Barışçıl Tetralar', 'Rasbora', 'Corydoras'],
      uyumsuz: ['Agresif balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Yumuşak su.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Erkekler daha kırmızı, daha büyük sırt yüzgeci.',
      gorunus: 'Yarı şeffaf kırmızı vücut. Siyah omuz lekesi. Uzun sırt yüzgeci.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'harlequin-rasbora',
      isim: 'Harlequin Rasbora',
      latince: 'Trigonostigma heteromorpha',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Trigonostigma_heteromorpha.jpg/1280px-Trigonostigma_heteromorpha.jpg',
      zorluk: 'Kolay',
      genel: 'Teknik olarak Rasbora ama Tetra benzeri davranış. Güneydoğu Asya\'dan. Çok popüler sürü balığı.',
      minLitre: 60,
      maxBoy: 5,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 3, max: 12 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Tetralar', 'Diğer Rasbora', 'Corydoras', 'Küçük Gurami', 'Barışçıl balıklar'],
      uyumsuz: ['Büyük balıklar', 'Agresif türler'],
      ureme: 'Yumurtlayan. Yaprak altına yumurta.',
      eslesme: 'Geniş yapraklı bitkilerin altına.',
      grupSayisi: '8+ (sürü)',
      disiErkek: 'Erkeklerde siyah üçgen daha belirgin ve sivri.',
      gorunus: 'Bakır-pembe vücut, belirgin siyah üçgen/kama deseni.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    }
  ]
};

export default { labirentliler, tetralar };